import SharedConsolidatedLevelData from '@/shared/models/ConsolidatedLevelData'

export default class ConsolidatedLevelData extends SharedConsolidatedLevelData {

}